(function($){    
    $("#yearSelect").on('change', function(e){
        var currentYear = new Date().getFullYear();
        currentYear = currentYear.toString();

        if( $(this).val() !== currentYear ) {
            $(this).closest('form').submit();
        } else {
            window.location.href = window.location.origin + window.location.pathname;
        }
    })
})(jQuery);
